var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-main"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.seeLoading)?_c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"image"},[_vm._v("Loading...")])]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }